<footer *ngIf="showFooter">
    <div>
        <app-disclaimer-links [isAppFooter]=true [isSmallFont]="true"/>
    </div>
    <div>
        <app-footer-copyright/>
    </div>
</footer>
